import { createContext, useContext } from 'react';

import { FormExternalConditionData } from '@components/form';

export type DynamicFieldsContextValue = {
  addRepeatingFieldEntry(id: string): void;
  removeRepeatingFieldEntry(id: string): void;
  externalData?: FormExternalConditionData;
};

const DynamicFieldsContext = createContext({} as DynamicFieldsContextValue);

export const DynamicFieldsProvider = DynamicFieldsContext.Provider;

export const useDynamicFieldsContext = () => {
  return useContext(DynamicFieldsContext);
};
